export default "__VITE_ASSET__BvH$c5l3__"